import React, { useEffect, useState } from 'react';
import { BOAPI } from "../service/UsersService";

const DAYS = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];

const VARIABLES = [
  ['{start}', 'תאריך תחילת התקופה (עברי)'],
  ['{end}', 'תאריך סוף התקופה (עברי)'],
  ['{date}', 'תאריך הפקת הדוח (עברי)'],
  ['{total}', 'סך המשימות שהושלמו'],
  ['{active}', 'משתמשים פעילים'],
  ['{new}', 'משתמשים חדשים'],
  ['{personal}', 'משימות אישיות (מספר בלבד)'],
  ['{trend}', 'משפט השוואה לדוח הקודם'],
];

const SHOW_TOGGLES = [
  ['showActiveUsers', 'כרטיס "משתמשים פעילים"'],
  ['showNewUsers', 'כרטיס "משתמשים חדשים" + משפט על מצטרפים'],
  ['showPersonalTasks', 'כרטיס "משימות אישיות" (מספר מצטבר בלבד, חסוי)'],
  ['showBreakdown', 'טבלת פילוח לפי סוג שיעור'],
  ['showTrend', 'משפט השוואה לדוח הקודם'],
];

const pad = (n) => String(n).padStart(2, '0');

const fromServer = (row) => ({
  isEnabled: !!row.isEnabled,
  sendDayOfWeek: Number(row.sendDayOfWeek),
  sendHour: Number(row.sendHour),
  sendMinute: Number(row.sendMinute),
  recipientEmail: row.recipientEmail || '',
  title: row.title || '',
  introTemplate: row.introTemplate || '',
  extraText: row.extraText || '',
  footerTemplate: row.footerTemplate || '',
  showActiveUsers: !!row.showActiveUsers,
  showNewUsers: !!row.showNewUsers,
  showPersonalTasks: !!row.showPersonalTasks,
  showBreakdown: !!row.showBreakdown,
  showTrend: !!row.showTrend,
  runNowRequested: !!row.runNowRequested,
});

const formatDate = (ymd) => {
  if (!ymd) return '';
  const [y, m, d] = ymd.slice(0, 10).split('-');
  return `${d}/${m}/${y}`;
};

const WeeklyReportTab = () => {
  const [form, setForm] = useState(null);
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [info, setInfo] = useState(null);
  const [preview, setPreview] = useState(null);   // { id, html }

  useEffect(() => { load(); }, []);

  const load = async () => {
    try {
      setLoading(true);
      setError(null);
      const result = await BOAPI.fetchWeeklyReport();
      if (Array.isArray(result) && result[0]?.[0]?.code === 0) {
        if (result[1]?.[0]) setForm(fromServer(result[1][0]));
        setReports(Array.isArray(result[2]) ? result[2] : []);
      } else {
        setError(result?.[0]?.[0]?.msg || 'שגיאה בטעינת הנתונים — ודאו שהרצתם את WeeklyRebbeReports.sql');
      }
    } catch (err) {
      setError(err.message || 'שגיאה בטעינת הנתונים');
    } finally {
      setLoading(false);
    }
  };

  const set = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

  const call = async (fn, successFallback) => {
    setError(null);
    setInfo(null);
    try {
      const resp = await fn();
      const status = Array.isArray(resp) ? resp[0]?.[0] : null;
      if (status?.code === 0) {
        setInfo(status.msg || successFallback);
        return true;
      }
      setError(status?.msg || 'הפעולה נכשלה');
    } catch (err) {
      setError(err.message || 'הפעולה נכשלה');
    }
    return false;
  };

  const handleSave = async () => {
    setSaving(true);
    await call(() => BOAPI.saveWeeklyReportSettings({
      ...form,
      sendDayOfWeek: Number(form.sendDayOfWeek),
      sendHour: Number(form.sendHour),
      sendMinute: Number(form.sendMinute),
    }), 'ההגדרות נשמרו');
    setSaving(false);
  };

  const handleRunNow = async () => {
    if (!window.confirm('להפיק עכשיו דוח חדש ולשלוח אותו במייל? אם כבר הופק דוח היום — הוא יוחלף. הדוח החדש יופיע גם באפליקציה.')) return;
    if (await call(() => BOAPI.runWeeklyReportNow(), 'הבקשה נשלחה')) {
      // שרת ה-jobs בודק כל דקה — מרעננים את הרשימה אחרי זמן סביר
      setTimeout(load, 70 * 1000);
    }
  };

  const handleResend = async (item) => {
    if (!window.confirm(`לשלוח שוב את הדוח מתאריך ${formatDate(item.reportDate)} במייל?`)) return;
    if (await call(() => BOAPI.resendWeeklyReportEmail(item.id), 'המייל יישלח שוב')) load();
  };

  const handleView = async (item) => {
    setError(null);
    try {
      const resp = await BOAPI.fetchWeeklyReportHtml(item.id);
      if (Array.isArray(resp) && resp[0]?.[0]?.code === 0 && resp[1]?.[0]?.html) {
        setPreview({ id: item.id, html: resp[1][0].html });
      } else {
        setError('לא ניתן לטעון את הדוח');
      }
    } catch (err) {
      setError(err.message || 'לא ניתן לטעון את הדוח');
    }
  };

  if (loading) return <div style={s.center}>טוען...</div>;

  return (
    <div style={s.container}>
      <div style={s.headerSection}>
        <h2 style={s.title}>דוח שבועי לרבי</h2>
        {form && <button onClick={handleRunNow} style={s.runButton}>▶️ הפק ושלח עכשיו</button>}
      </div>

      {error && (
        <div style={s.error}>
          ❌ {error}
          <button onClick={() => setError(null)} style={s.closeErrorButton}>✕</button>
        </div>
      )}
      {info && (
        <div style={s.infoBox}>
          ✅ {info}
          <button onClick={() => setInfo(null)} style={s.closeInfoButton}>✕</button>
        </div>
      )}

      {form && (
        <div style={s.formCard}>
          <h3 style={s.formTitle}>מועד השליחה</h3>
          <div style={s.formGroup}>
            <label style={s.checkboxLabel}>
              <input type="checkbox" checked={form.isEnabled} onChange={(e) => set('isEnabled', e.target.checked)} style={s.checkbox} />
              שליחה אוטומטית שבועית פעילה
            </label>
          </div>
          <div style={s.formRow}>
            <div style={s.formGroup}>
              <label style={s.label}>יום בשבוע</label>
              <select value={form.sendDayOfWeek} onChange={(e) => set('sendDayOfWeek', e.target.value)} style={s.input}>
                {DAYS.map((d, i) => <option key={i} value={i}>יום {d}</option>)}
              </select>
            </div>
            <div style={s.formGroup}>
              <label style={s.label}>שעה (שעון ישראל)</label>
              <div style={s.timeRow}>
                <select value={form.sendHour} onChange={(e) => set('sendHour', e.target.value)} style={s.input}>
                  {Array.from({ length: 24 }, (_, h) => <option key={h} value={h}>{pad(h)}</option>)}
                </select>
                <span style={s.colon}>:</span>
                <select value={form.sendMinute} onChange={(e) => set('sendMinute', e.target.value)} style={s.input}>
                  {Array.from({ length: 12 }, (_, i) => i * 5).map((m) => <option key={m} value={m}>{pad(m)}</option>)}
                  {form.sendMinute % 5 !== 0 && <option value={form.sendMinute}>{pad(form.sendMinute)}</option>}
                </select>
              </div>
            </div>
            <div style={s.formGroup}>
              <label style={s.label}>כתובת מייל לשליחה</label>
              <input
                type="email"
                value={form.recipientEmail}
                onChange={(e) => set('recipientEmail', e.target.value)}
                style={s.input}
                maxLength={200}
                placeholder="ריק = לפי RABBI_REPORT_EMAIL בשרת"
              />
            </div>
          </div>
          <div style={s.hint}>
            הזמן מוצג גם באפליקציה (הספירה לאחור בעיגול הראשי). שינוי המועד חל מהשבוע הקרוב; אם השרת היה כבוי ברגע השליחה — הדוח יופק בדיעבד עד 6 שעות אחר כך.
          </div>

          <h3 style={{ ...s.formTitle, marginTop: 24 }}>תוכן הדוח</h3>
          <div style={s.formGroup}>
            <label style={s.label}>כותרת *</label>
            <input type="text" value={form.title} onChange={(e) => set('title', e.target.value)} style={s.input} maxLength={100} />
          </div>
          <div style={s.formGroup}>
            <label style={s.label}>פסקת פתיחה *</label>
            <textarea value={form.introTemplate} onChange={(e) => set('introTemplate', e.target.value)} style={s.textarea} rows={3} maxLength={1000} />
          </div>
          <div style={s.formGroup}>
            <label style={s.label}>טקסט נוסף (אופציונלי — מופיע בסוף הדוח, לדוגמה ברכה או בקשה)</label>
            <textarea value={form.extraText} onChange={(e) => set('extraText', e.target.value)} style={s.textarea} rows={3} maxLength={2000} />
          </div>
          <div style={s.formGroup}>
            <label style={s.label}>שורת סיום *</label>
            <input type="text" value={form.footerTemplate} onChange={(e) => set('footerTemplate', e.target.value)} style={s.input} maxLength={500} />
          </div>

          <div style={s.varsBox}>
            <b>משתנים שאפשר להכניס לטקסטים (הם יוחלפו במספרים / תאריכים אמיתיים):</b>
            <div style={s.varsGrid}>
              {VARIABLES.map(([v, d]) => (
                <div key={v}><code style={s.code}>{v}</code> — {d}</div>
              ))}
            </div>
          </div>

          <div style={s.formGroup}>
            <label style={s.label}>מה להציג בדוח</label>
            {SHOW_TOGGLES.map(([key, text]) => (
              <label key={key} style={{ ...s.checkboxLabel, marginBottom: 8 }}>
                <input type="checkbox" checked={form[key]} onChange={(e) => set(key, e.target.checked)} style={s.checkbox} />
                {text}
              </label>
            ))}
          </div>

          <div style={s.formButtons}>
            <button onClick={handleSave} disabled={saving} style={s.saveButton}>{saving ? 'שומר...' : '💾 שמור הגדרות'}</button>
          </div>
          {form.runNowRequested && <div style={s.hint}>⏳ יש בקשת "הפק ושלח עכשיו" שממתינה לשרת (נבדק כל דקה).</div>}
        </div>
      )}

      <h3 style={s.sectionTitle}>דוחות שהופקו</h3>
      {reports.length === 0 ? (
        <div style={s.noData}>עוד לא הופקו דוחות</div>
      ) : (
        <div style={s.tableWrapper}>
          <table style={s.table}>
            <thead>
              <tr style={s.headerRow}>
                <th style={s.th}>תאריך</th>
                <th style={s.th}>משימות</th>
                <th style={s.th}>מתוכן אישיות</th>
                <th style={s.th}>פעילים</th>
                <th style={s.th}>חדשים</th>
                <th style={s.th}>מייל</th>
                <th style={s.th}>פעולות</th>
              </tr>
            </thead>
            <tbody>
              {reports.map((r) => (
                <tr key={r.id} style={s.row}>
                  <td style={s.td}>{formatDate(r.reportDate)}</td>
                  <td style={s.td}>{r.totalTasks}</td>
                  <td style={s.td}>{r.personalTasks}</td>
                  <td style={s.td}>{r.activeUsers}</td>
                  <td style={s.td}>{r.newUsers}</td>
                  <td style={s.td}>
                    <span style={{ ...s.statusBadge, backgroundColor: r.emailSent ? '#e8f5e9' : '#fff3e0', color: r.emailSent ? '#2e7d32' : '#ef6c00' }}>
                      {r.emailSent ? '✓ נשלח' : r.resendRequested ? 'ממתין לשליחה חוזרת' : 'לא נשלח'}
                    </span>
                  </td>
                  <td style={s.td}>
                    <div style={s.actionButtons}>
                      <button onClick={() => handleView(r)} style={s.editButton}>👁 צפייה</button>
                      <button onClick={() => handleResend(r)} style={s.resendButton}>✉️ שלח שוב</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {preview && (
        <div style={s.overlay} onClick={() => setPreview(null)}>
          <div style={s.modal} onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setPreview(null)} style={s.modalClose}>✕ סגור</button>
            <iframe title="report-preview" srcDoc={preview.html} sandbox="" style={s.iframe} />
          </div>
        </div>
      )}
    </div>
  );
};

const s = {
  container: { padding: '20px', direction: 'rtl', fontFamily: 'Arial, sans-serif' },
  headerSection: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px', marginBottom: '20px' },
  title: { margin: 0, color: '#1a1f36', fontSize: '24px', fontWeight: 'bold' },
  sectionTitle: { margin: '28px 0 12px', color: '#1a1f36', fontSize: '18px' },
  runButton: { padding: '10px 20px', backgroundColor: '#1f6feb', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold' },

  formCard: { backgroundColor: '#f9f9f9', padding: '20px', borderRadius: '8px', border: '1px solid #ddd', marginBottom: '20px' },
  formTitle: { marginTop: 0, marginBottom: '16px', color: '#333', fontSize: '18px' },
  formGroup: { marginBottom: '15px' },
  formRow: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' },
  label: { display: 'block', marginBottom: '5px', color: '#333', fontWeight: 'bold', fontSize: '14px' },
  input: { width: '100%', padding: '10px', fontSize: '14px', border: '1px solid #ddd', borderRadius: '4px', boxSizing: 'border-box', backgroundColor: 'white' },
  textarea: { width: '100%', padding: '10px', fontSize: '14px', border: '1px solid #ddd', borderRadius: '4px', boxSizing: 'border-box', fontFamily: 'Arial, sans-serif', resize: 'vertical' },
  timeRow: { display: 'flex', alignItems: 'center', gap: '6px', direction: 'ltr' },
  colon: { fontWeight: 'bold' },
  checkbox: { marginLeft: '8px', cursor: 'pointer' },
  checkboxLabel: { display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '14px' },
  hint: { color: '#777', fontSize: '13px', marginTop: '6px' },
  varsBox: { backgroundColor: '#fff', border: '1px dashed #ccc', borderRadius: '6px', padding: '12px', marginBottom: '16px', fontSize: '13px', color: '#555' },
  varsGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '6px', marginTop: '8px' },
  code: { direction: 'ltr', display: 'inline-block', backgroundColor: '#f0f0f0', padding: '1px 6px', borderRadius: '3px' },
  formButtons: { display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '10px' },

  tableWrapper: { overflowX: 'auto', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' },
  table: { width: '100%', borderCollapse: 'collapse', backgroundColor: 'white' },
  headerRow: { backgroundColor: '#f5f5f5', borderBottom: '2px solid #ddd' },
  th: { padding: '12px', textAlign: 'right', fontWeight: 'bold', color: '#333', fontSize: '14px', borderBottom: '2px solid #ddd' },
  row: { borderBottom: '1px solid #eee' },
  td: { padding: '12px', color: '#666', fontSize: '14px', textAlign: 'right', verticalAlign: 'middle' },

  statusBadge: { display: 'inline-block', padding: '6px 12px', borderRadius: '12px', fontSize: '12px', fontWeight: 'bold' },
  actionButtons: { display: 'flex', gap: '8px' },
  editButton: { padding: '8px 14px', backgroundColor: '#1f6feb', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold' },
  resendButton: { padding: '8px 14px', backgroundColor: '#6d4c41', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold' },
  saveButton: { padding: '10px 20px', backgroundColor: '#2e7d32', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold' },

  center: { textAlign: 'center', padding: '40px', color: '#999' },
  error: { padding: '15px', backgroundColor: '#ffebee', color: '#c62828', borderRadius: '4px', marginBottom: '20px', fontSize: '14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  closeErrorButton: { backgroundColor: 'transparent', color: '#c62828', border: 'none', cursor: 'pointer', fontSize: '18px', fontWeight: 'bold' },
  infoBox: { padding: '15px', backgroundColor: '#e8f5e9', color: '#2e7d32', borderRadius: '4px', marginBottom: '20px', fontSize: '14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  closeInfoButton: { backgroundColor: 'transparent', color: '#2e7d32', border: 'none', cursor: 'pointer', fontSize: '18px', fontWeight: 'bold' },
  noData: { padding: '40px', textAlign: 'center', color: '#999', backgroundColor: '#f5f5f5', borderRadius: '4px' },

  overlay: { position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '16px' },
  modal: { backgroundColor: 'white', borderRadius: '8px', width: '100%', maxWidth: '720px', height: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' },
  modalClose: { alignSelf: 'flex-start', margin: '8px', padding: '6px 12px', backgroundColor: '#eee', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '13px' },
  iframe: { flex: 1, border: 'none', width: '100%' },
};

export default WeeklyReportTab;
